module.exports = __webpack_public_path__ + "static/img/ddcj01.620d676.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/ddcj01.jpg
// module id = 1430
// module chunks = 0